import predictions from '../core/data/predictions.json'

const futurePredictions = predictions
  .map(prediction => ({
    label: prediction.event,
    probability: prediction.yhat,
    date: new Date(new Date(prediction.ds).getTime() + 20 * 24 * 60 * 60 * 1000),
  }))
  .filter(prediction => prediction.probability > 0 && prediction.date > new Date(2023, 5, 10))

export function getPrediction(regionName) {
  return futurePredictions
}
